import './App.css';
import Portfolio from './component/Portfolio'

function App() {
  return (
    <div className="App">
      <Portfolio/>
    </div>
  );
}

export default App;
